<template>
    <div class="mt-4">
        <b-form-group
                vertical
                :label-cols="2"
                breakpoint="lg"
                label="Diagnosis">
            <b-form-textarea v-validate="'required'" name="diagnosis" @input="dataSetter($event, 'diagnosis')"
                             :rows="10" v-model="appointment.diagnosis"></b-form-textarea>
            <span class="error">{{ errors.first('diagnosis') }}</span>
        </b-form-group>
    </div>
</template>

<script>
  import FormDataSetter from '@/mixins/form-data-setter';

  export default {
    inject: ['$validator'],
    props: {
      appointment: {
        type: Object
      }
    },
    mixins: [FormDataSetter]
  }
</script>



// WEBPACK FOOTER //
// src/views/Appointment/Form/DiagnosisTab.vue